export default "__VITE_ASSET__qOXwa2Ut__"